import * as React from "react";
import type { SVGProps } from "react";
const SvgToggleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M16.8 16.8H7.2a4.8 4.8 0 1 1 0-9.6h9.6m0 9.6a4.8 4.8 0 1 0 0-9.6m0 9.6a4.8 4.8 0 0 1 0-9.6"
    />
  </svg>
);
export default SvgToggleRight;
